import { IAddAgreement, IAgreementListVM } from "../../models/forms/IAgreement";

export const agreementInitialState: IAgreementListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  AgreementVM: [],
};

export const initialAgreementValues: IAddAgreement = {
  Id: 0,
  AgreementName: "",
  BusinessTypeId: 0,
  Content: "",
  IsValid: "IsNotValid"
};
